// RULING 250 (2026-09-29, muster 092926-1; Bob: "agreed to your recommendation"). Box 5 of QuickFile
// suggests exhibits FROM THE CLAIM'S OWN FACTS. Each suggestion says why it is suggested and where the
// document is found. Nothing here is added to the claim until the member presses "+ Add" on it.
//
// Retrieval only (ruling 27): a suggestion names a document and the fact that prompted it. It never
// states what a document proves, and it never invents a document the claim's facts do not point to.
// Links are shown only where the platform holds the document; today none of these is held, so each
// suggestion names where it is found instead (the Agreements library, the carrier, the member).

const clean = v => (v == null ? '' : String(v).trim());

export function suggestExhibits({ matchedRules, agreement, claim } = {}) {
  const c = claim || {};
  const out = [];
  const seen = new Set();
  const push = (s) => { if (!seen.has(s.id)) { seen.add(s.id); out.push(s); } };

  (Array.isArray(matchedRules) ? matchedRules : []).forEach((r) => {
    const rule = clean(r && r.rule);
    if (!rule) return;
    const title = clean(r.fullTitle);
    push({
      id: 'rule:' + rule,
      description: 'Text of ' + rule + (title ? ' - ' + title : '') + (agreement ? ' (' + agreement + ')' : ''),
      why: 'The rule this claim rests on.',
      where: 'Agreements library on this platform.',
    });
  });

  const date = clean(c.incidentDate);
  if (date) {
    push({
      id: 'time:' + date,
      description: 'Your time record for ' + date,
      why: 'Shows your status on the date of the claim.',
      where: 'Carrier timekeeping, or your own copy.',
    });
  }

  const violator = clean(c.violatorName);
  if (violator) {
    push({
      id: 'roster:' + violator,
      description: 'Seniority roster showing you and ' + violator,
      why: 'You named another employee; the roster shows where each of you stands.',
      where: 'Your Local or General Chairperson, or the posted roster.',
    });
  }

  const witnesses = clean(c.witnesses);
  if (witnesses) {
    push({
      id: 'witness:' + witnesses,
      description: 'Written statement from each witness (' + witnesses + ')',
      why: 'You named witnesses.',
      where: 'From each witness, signed and dated.',
    });
  }

  return out;
}
